import React, {useEffect, useState} from 'react';
import {InputGroup, Button, TextArea, Card, H3, Popover} from '@blueprintjs/core'
import styled from 'styled-components'

import {Table, Row, Cell} from '/src/components/tables/table'
import {device} from "/src/services/iot-api";
import {recordings} from "/src/services/api";
import {errorToast} from "/src/utils/toaster";


const CreatingCardContainer = styled.div`
    display: block;
    padding: 1em;
    
`

const resizeBlob = (blob, height = 480) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(blob);

        img.onload = () => {

            const ratio = height / img.height;
            // Draw onto canvas
            const canvas = document.createElement("canvas");
            canvas.width = ratio * img.width;
            canvas.height = ratio * img.height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Export as Base64 (jpeg with 70% quality here)
            const base64String = canvas.toDataURL("image/jpeg", 0.7);
            URL.revokeObjectURL(url); // Clean up
            resolve({img: base64String.split(",")[1], height: canvas.height, width: canvas.width});
        };

        img.onerror = reject;
        img.src = url;
    });
}

const CreatingCard = ({onConfirm}) => {
    const [nameInput, setNameInput] = useState("");

    return <CreatingCardContainer>
        <H3>Create thumbnail</H3>
        <InputGroup
            type="text"
            leftIcon="edit"
            placeholder="Camera name"
            value={nameInput}
            onChange={e => setNameInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter'? onConfirm(nameInput) : null}
        />
        <Button
            fill={true}
            text="Create recid"
            intent="primary"
            disabled={nameInput.length === 0}
            onClick={() => onConfirm(nameInput)}
        />

    </CreatingCardContainer>
}


const Thumbnail = ({thumbnail, onCreate, onRemove}) => {
    const [loading, setLoading] = useState(false);
    const [showButtons, setShowButtons] = useState(false);

    return <Table
        onMouseOver={() => setShowButtons(true)}
        onMouseLeave={() => setShowButtons(false)}
    >
        <Row margin='auto auto 20px auto' $separatorColor='silver'></Row>

        <Row>
            <Cell halign="center" valign="center">
                <img src={URL.createObjectURL(thumbnail.blob)} alt="" width="100%"/>
            </Cell>
        </Row>
        <Row>
            <Cell span={5}>
                <TextArea
                    fill={true}
                    disabled={true}
                    value={thumbnail.url}
                    autoResize={true}
                />
            </Cell>
            {showButtons ? <Cell span={1}>
                <div>
                    <Button
                        minimal={true}
                        icon="add"
                        title="Create recording"
                        loading={loading}
                        onClick={() => {
                            if (onCreate) {
                                setLoading(true);
                                onCreate(thumbnail.url)
                                setLoading(false);
                            }
                        }}
                    />
                    <Button
                        minimal={true}
                        icon="trash"
                        title="Remove"
                        loading={loading}
                        onClick={() => onRemove && onRemove(thumbnail)}
                    />
                </div>
            </Cell> : null}
        </Row>
    </Table>
}


const ThumbnailsControl = ({deviceName, onCreate}) => {
    const [thumbnails, setThumbnails] = useState([]);
    const [currentText, setCurrentText] = useState('');
    const [loading, setLoading] = useState(false);
    const [creating, setCreating] = useState(null);

    useEffect(() => {
        console.log(creating);
    }, [creating]);

    return <Table>
        <Row>
            <Cell span={1}>
                <Button
                    // style={{padding: '10px'}}
                    text="Request"
                    intent="primary"
                    loading={loading}
                    onClick={() => {
                        if (currentText) {
                            console.log(`Requesting ${currentText}`);
                            setLoading(true);

                            device.command(
                                'GetThumbnailCommand', deviceName, {source: currentText}
                            ).then((resp) => {
                                console.log(`Finished requesting ${currentText}`);
                                if (resp.payload?.resp?.error) {
                                    // if the response from the IoTWrapper has an error
                                    errorToast({message: resp.payload.resp.error})
                                } else {
                                    // ----- construct blob from response
                                    const blob = new Blob([
                                        new Uint8Array(atob(resp.payload.resp).split('').map(c => c.charCodeAt(0)))
                                    ], {type: 'image/jpg'});
                                    setThumbnails(
                                        [
                                            ...thumbnails,
                                            {url: currentText, blob: blob}
                                        ].map((t, i) => ({...t, id: i}))
                                    );
                                    setCurrentText('');
                                }
                            }).catch((err) => {
                                console.log(err);
                                errorToast({message: err?.message ?? String(err)})
                            }).finally(() => setLoading(false));
                        } else {
                            console.log("Nothing to request");
                            errorToast({message: "Please specify an RTSP url"});
                        }
                    }}
                />
            </Cell>
            <Cell span={6}>
                <InputGroup
                    fill small
                    value={currentText}
                    disabled={loading}
                    placeholder="Enter an rtsp url here"
                    onChange={e => setCurrentText(e.target.value)}
                />
            </Cell>
        </Row>
        {thumbnails.map((thumbnail) => {
            return <Row key={thumbnail.id}>
                <Cell>
                    <Popover
                        isOpen={!!creating && creating.id === thumbnail.id}
                        onClose={() => setCreating(null)}
                        content={
                            <CreatingCard
                                onConfirm={
                                    (name) => {
                                        console.log(`Creating ${name}`);
                                        resizeBlob(creating.blob).then(({img, width, height}) => {
                                            onCreate({name, img, width, height, source: creating.url});
                                        }).finally(() => setCreating(null));
                                    }
                                }
                            />
                        }
                    >
                        <Thumbnail
                            thumbnail={thumbnail}
                            onCreate={() => setCreating(thumbnail)}
                            onRemove={(thumb) => {
                                console.log(`Remove thumbnail ${thumb.id}`);
                                thumbnails.splice(thumb.id, 1);
                                setThumbnails([...thumbnails].map((t, i) => ({...t, id: i})));
                            }}
                        />
                    </Popover>
                </Cell>
            </Row>
        })}
    </Table>
}

export {ThumbnailsControl};